import { createUseStyles } from 'react-jss'

export const style = {
  emptyState: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  emptyStateSafari: {
    height: '100svh'
  }
}

export const useStyles = createUseStyles(style)
